export default __webpack_public_path__ + "static/media/IconDesc_PowerSwitch.256.c96fe88c.png";